<template>
    <div v-if="isLoading" class="loading-overlay"><p>Carregando...</p></div>

    <MensagemAlerta class="row-space" v-if="errorMessage" :mensagem="errorMessage" />

    <div v-if="showPesquisa">
        <div class="form-edit-page row-space">
            <div class="row">
                <div class="form-item">
                    <label class="label-caption">Pesquisa Nome</label>
                    <input type="text" v-model="nmPesquisa" maxlength="60" v-uppercase />
                </div>
                <button type="button" class="buttom-icon--search" @click="lerDados" />
                <button type="button" class="buttom-icon--close" @click="closeForm" />
            </div>
        </div>
        
        <table>
            <thead>
                <tr>
                    <th class="col-width-integer">Nro OS</th>
                    <th class="col-width-date">Execução</th>
                    <th>Nome</th>
                    <th class="col-width-char20">Contratado</th>
                    <th class="col-width-char20">Executado</th>
                    <th class="col-width-char20">Valor Saldo</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(obj, index) in lsDados" :key="obj.id" :class="{'even-row': index % 2 === 0, 'odd-row': index % 2 !== 0, 'clickabe-row': true}" @click="setEdicao(obj)">
                    <td class="col-width-integer right">{{ Funcoes.formatInteger(obj.cdos) }}</td>
                    <td class="col-width-date center">{{ Funcoes.formatDateFromJson(obj.dtfim) }}</td>
                    <td>{{ obj.nmpessoa }}</td>
                    <td class="col-width-char20 center">{{ obj.hrcontratadas }}</td>
                    <td class="col-width-char20 center">{{ obj.hrtrabalhadas }}</td>
                    <td class="col-width-char20 right">{{ Funcoes.formatDecimal(obj.vlbanco_horas) }}</td>
                </tr>
            </tbody>
        </table>


        <div v-if="showPagination" class="pagination">
            <button :disabled="currentPage === 1" class="buttom-pagination--first" @click="currentPage=1; updatePaginatedData();" />
            <button :disabled="currentPage === 1" class="buttom-pagination--prior" @click="currentPage--; updatePaginatedData();" />

            <div class="field-label field-label-center">{{ currentPage }} de {{ Math.ceil(lsDadosMain.length / itemsPerPage) }}</div>

            <button :disabled="currentPage === Math.ceil(lsDadosMain.length / itemsPerPage)" class="buttom-pagination--next" @click="currentPage++; updatePaginatedData();" />
            <button :disabled="currentPage === Math.ceil(lsDadosMain.length / itemsPerPage)" class="buttom-pagination--last" @click="currentPage = Math.ceil(lsDadosMain.length / itemsPerPage); updatePaginatedData();" />
        </div>
    </div>

    <div v-if="!showPesquisa">
        <div class="form-edit-page row-space">
            <div class="row row-space">
                <div class="form-item-char10">
                    <label class="label-caption">Nro OS</label>
                    <div class="field-label field-label-end">{{ Funcoes.formatInteger(objEdicao.cdos) }}</div>
                </div>

                <div class="form-item-char10">
                    <label class="label-caption">Execução</label>
                    <div class="field-label field-label-center">{{ Funcoes.formatDateFromJson(objEdicao.dtfim) }}</div>
                </div>

                <div class="form-item">
                    <label class="label-caption">Nome</label>
                    <div class="field-label">{{ objEdicao.nmpessoa }}</div>
                </div>                

                <div class="form-item-char20">
                    <label class="label-caption">Contratado</label>
                    <div class="field-label field-label-center">{{ objEdicao.hrcontratadas }}</div>
                </div>

                <div class="form-item-char20">
                    <label class="label-caption">Executado</label>
                    <div class="field-label field-label-center">{{ objEdicao.hrtrabalhadas }}</div>
                </div>
            </div>


            <div class="row row-space">
                <div class="form-item">
                    <label class="label-caption">Serviço</label>
                    <div class="field-label">{{ objEdicao.nmservico }}</div>
                </div>

                <div class="form-item">
                    <label class="label-caption">Localidade</label>
                    <div class="field-label">{{ objEdicao.nmlocalidade }}</div>
                </div>
            </div>


            <div class="row row-space">
                <div class="form-item-char20">
                    <label class="label-caption">Saldo R$</label>
                    <div class="field-label field-label-end">{{ Funcoes.formatDecimal(objEdicao.vlbanco_horas) }}</div>
                </div>

                <div class="form-item">
                    <label class="label-caption">Justificativa (Apenas Estorno)</label>
                    <input type="text" v-model="edInfo" maxlength="200" v-uppercase />
                </div>
            </div>


            <div class="row-end">
                <button class="btn-confirm" @click="salvarDados(1)">Lançar Banco</button>
                <button class="btn-cancel" @click="salvarDados(9)">Estornar Saldo</button>
                <button @click="showPesquisa=true">Cancelar</button>
            </div>
        </div>
    </div>
</template>


<script setup>
import { ref } from 'vue';
import { Funcoes } from '@/funcoes/utils';
import { genericPost, genericPut } from '@/funcoes/api'; 
import { globalStore } from '@/globals';
import MensagemAlerta from '@/components/MensagemAlerta.vue';

const emit=defineEmits(['close']);

const errorMessage = ref(null);
const isLoading = ref(false);
const lsDados = ref([]);
const nmPesquisa = ref(null);
const objEdicao = ref(null);
const showPesquisa = ref(true);

const edInfo = ref(null);

const currentPage = ref(1);
const itemsPerPage = ref(globalStore.itensPorPagina);
const lsDadosMain = ref([]);
const showPagination = ref(false);

const closeForm = () => {emit('close');}

const lerDados = async() => {
    try{
        errorMessage.value  = null;
        isLoading.value     = true;
        const req = await genericPost('/listas/ossobras_aguardando', {
            idmunicipio: globalStore.idmunicipio,
            nmpesquisar: nmPesquisa.value});
        lsDadosMain.value = req;
        currentPage.value=1;
        showPagination.value = (lsDadosMain.value.length > itemsPerPage.value);
        updatePaginatedData();
    } catch (error){errorMessage.value=error;
    } finally {isLoading.value = false;}
}

const salvarDados = async(opcaoAnalise) =>{
    if ((opcaoAnalise===9) && (!edInfo.value)){errorMessage.value='Informe justificativa para estorno do saldo'; return;}
    try{
        errorMessage.value          = null;
        isLoading.value             = true;
        await genericPut('/os/processar_saldo_banco', {
            idos: objEdicao.value.id,
            intparam1: opcaoAnalise,
            strparam1: edInfo.value,
            idusuario: globalStore.idusuario});

        showPesquisa.value = true;
        lerDados();
    } catch (error){
        // Verifica se a API retornou um erro esperado
        if (error.response && error.response.data) {
            errorMessage.value = error.response.data; // Pega a mensagem da API
        } else {
            errorMessage.value = 'Erro desconhecido. Tente novamente.';
        }
    } finally {isLoading.value = false;}
}

const setEdicao = async(obj) =>{
    objEdicao.value         = obj;
    showPesquisa.value      = false;
}

const updatePaginatedData = () => {
    const startIndex = (currentPage.value - 1) * itemsPerPage.value;
    const endIndex = (startIndex + itemsPerPage.value);
    lsDados.value = lsDadosMain.value.slice(startIndex, endIndex);
}
</script>
